/**
 * Get array of string values from an enum.
 *
 * For example:
 *
 * enum SomeEnum {
 *   "TIME",
 *   "REPS",
 * }
 *
 * gives ["TIME", "REPS"]
 *
 * Copied from https://stackoverflow.com/a/51536142/1657101
 */

// Helper
const StringIsNumber = (value: string) => isNaN(Number(value)) === false;

// Turn enum into array
function enumToArray(enumme: any) {
  return Object.keys(enumme)
    .filter(StringIsNumber)
    .map((key) => enumme[key]);
}

export default enumToArray;
